import {Injectable} from '@angular/core';
import {BasePagedCrudService} from '../shared/crud/base-crud.service';
import { HttpClient } from '@angular/common/http';
import {ApiAttributeParams, CrudSettings, QueryParams} from '../shared/crud/abstractions/base-crud';
import {
  CreateCRORegistrationDto,
  CRORegistrationBasicDto,
  EditCRORegistrationDto,
  EditCRORegistrationPasswordDto
} from './models/CRORegistrationDtos';
import {EnvironmentService} from '../core/environment/environment.service';
import {DialogService} from "../shared/dialog/dialog.service";
import {BehaviorSubject, lastValueFrom} from "rxjs";
import {ShowType, SnackMessage} from "../shared/dialog/snack-bar/snack-bar/snack-bar.component";

export class CroRegistrationCrudSettings implements CrudSettings<string, CRORegistrationBasicDto> {
  baseUrl = '';
  postUrl = undefined;
  queryParam: string | undefined;
  createSuffix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix = undefined;
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = 'multiple';
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  idGetter = (entity: CRORegistrationBasicDto) => entity.id;

  mapper(id: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('id', id);
    return { params: dict }
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.baseUrl + '/api/CROIntegrations/CRORegistration';
  }
}

@Injectable({
  providedIn: null
})
export class CroRegistrationDataService
  extends BasePagedCrudService<string, CRORegistrationBasicDto, CreateCRORegistrationDto, EditCRORegistrationDto | EditCRORegistrationPasswordDto>{
  isBusy$: BehaviorSubject<boolean>;
  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new CroRegistrationCrudSettings(environmentService), dialogService);
    this.isBusy$ = new BehaviorSubject<boolean>(false)
  }
  async editPassword(id: string, entity: EditCRORegistrationPasswordDto){
    this.isBusy$.next(true)
    let res = null;
    try {
      const res$ = this._http.put<EditCRORegistrationPasswordDto>(`${this.getSettings().baseUrl}/registrationSecret`,entity)
      res = await lastValueFrom(res$)
      this.isBusy$.next(false)
      this.dialogService.openSnackBar(SnackMessage.EditEntitySucess, ShowType.Success)
    }
    catch (e) {
      await this.dialogService.handleError(e)
    }
    return res;
  }
}
